import { appEntry } from '@/mocks/homeData';

export default function SectionApp() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-100">
      <div className="mx-auto max-w-[1200px] px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full max-w-[480px] order-2 lg:order-1">
            <div className="relative w-full aspect-[9/16] max-h-[560px] rounded-2xl overflow-hidden bg-secondary-100 mx-auto max-w-[280px]">
              <img
                src="https://readdy.ai/api/search-image?query=Smartphone%20displaying%20colorful%20webtoon%20comic%20on%20screen%20with%20vertical%20scrolling%20layout%2C%20held%20in%20hand%20against%20warm%20cozy%20cafe%20background%2C%20soft%20natural%20lighting%2C%20modern%20minimal%20composition%2C%20clean%20and%20inviting%20aesthetic&width=560&height=990&seq=app-mobile-manga&orientation=portrait"
                alt="樱花漫画网 - 手机阅读体验"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>

          <div className="flex-1 w-full order-1 lg:order-2 text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-primary-100/70 text-primary-700 text-xs font-medium mb-5">
              <i className="ri-smartphone-line"></i>
              <span>移动阅读</span>
            </div>
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 mb-4">{appEntry.title}</h2>
            <p className="text-foreground-600 text-sm md:text-base leading-relaxed mb-6 max-w-lg mx-auto lg:mx-0">
              {appEntry.desc}
            </p>
            <div className="grid grid-cols-2 gap-3 max-w-sm mx-auto lg:mx-0">
              {appEntry.features.map((feat, i) => (
                <div key={i} className="flex items-center gap-2 text-sm text-foreground-700">
                  <div className="w-6 h-6 flex items-center justify-center flex-shrink-0">
                    <i className="ri-check-line text-primary-500"></i>
                  </div>
                  <span>{feat}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}